export interface FlowDynamicStyle {
    systemCode: string;
    businessCode: string;
    productCode: string;
    kind: string;
    standardKey: string;
    codFlow: string;
    dateTimeStyle: {
        dateTimeLocale: string;
        dateTimeFormat: string;
    };
    globalFlowStyles: {
        hideSideBar: boolean;
    };
};

export const DatetimeFormats: string[] = [
    'short',
    'medium',
    'long',
    'full',
    'shortDate',
    'mediumDate',
    'longDate',
    'fullDate'
];

// more can be added
export const DatetimeLocales: string[] = [
    'en',
    'es',
];



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/interfaces/flowDynamicStyle.interface.ts